module.exports = __webpack_public_path__ + "img/omnilogo.ce0b206c.png";